import {Map as MapLibre} from 'maplibre-gl';

import MapTileService from '@js/modules/maps/mapTileService';


const ElevationComputationMapModule = {
    _elevationComputationModel: {
        mapContainerId: 'map-elevation-computation',
        map: undefined,

        coordinateElevations: []
    },

    createElevationMap() {
        if (!document.getElementById(this._elevationComputationModel.mapContainerId)) {
            return;
        }

        this._elevationComputationModel.map = new MapLibre({
            container: this._elevationComputationModel.mapContainerId,
            style: MapTileService.mapPlannerStyle,
            attributionControl: false,
            interactive: false,
            hash: false
        });

        this._elevationComputationModel.map.once('style.load', () => {
            this._elevationComputationModel.map.setLayerZoomRange('hillshade', 6, 24);
            this._elevationComputationModel.map.setLayoutProperty('hillshade', 'visibility', 'visible');

            this._elevationComputationModel.map.setTerrain({
                'source': 'hillshade',
                'exaggeration': 1
            });
        });
    },

    // Callback return:
    // First parameter: coordinateElevations array of objects {lat: lng:, deltaDistance:, totalDistance:, elevation:}
    // Second parameter: simplifiedCoordinateElevations array of [totalDistance, elevation] (useful to compute elevation Apsis)
    computeElevation(callback) {
        if (!this._elevationComputationModel.map || !this._mapModel.linePoints.length) {
            return;
        }

        // We need to set position map position to be able to compute terrain elevation
        // Too long
        // const polygonBounds = this._buildBounds();
        // coordinates.forEach((point) => {
        //     polygonBounds = polygonBounds.extend([point.lng, point.lat]);
        // });
        // this._elevationComputationModel.map.fitBounds(polygonBounds, {padding: 50});
        this._elevationComputationModel.map.setCenter([this._mapModel.linePoints[0].latLng.lng, this._mapModel.linePoints[0].latLng.lat]);
        this._elevationComputationModel.map.setZoom(12);

        // We need to wait the bounds are set to compute terrain elevation
        this._elevationComputationModel.map.once('idle', () => {
            this._elevationComputationModel.coordinateElevations = [];

            let totalDistance = 0;
            this._mapModel.linePoints.forEach((linePoint) => {
                totalDistance += linePoint.deltaDistance;

                this._elevationComputationModel.coordinateElevations.push({
                    lat: linePoint.latLng.lat,
                    lng: linePoint.latLng.lng,
                    deltaDistance: linePoint.deltaDistance,
                    totalDistance: totalDistance,
                    elevation: Number.isFinite(linePoint.elevation)
                        ? Math.round(linePoint.elevation)
                        : parseInt(this._elevationComputationModel.map.queryTerrainElevation([linePoint.latLng.lng, linePoint.latLng.lat]))
                });
            });

            const elevationGraph = this._elevationComputationModel.coordinateElevations.map((coordElevation) => {
                return [coordElevation.totalDistance, coordElevation.elevation];
            });

            const simplifiedCoordinateElevations = this.simplifyLine(elevationGraph, {
                defaultTolerance: 0.1,
                convertToXY: true
            });

            callback(
                this._elevationComputationModel.coordinateElevations,
                simplifiedCoordinateElevations
            );
        });
    },

    clearElevationMap() {
        if (!this._elevationComputationModel.map) {
            return;
        }

        this._elevationComputationModel.coordinateElevations = [];
    },

    destroyElevationMap() {
        if (!this._elevationComputationModel.map) {
            return;
        }

        this._elevationComputationModel.coordinateElevations = [];

        this._elevationComputationModel.map.remove();
    }

    /* Private Methods
    ******************** */
};

export default ElevationComputationMapModule;
